var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.84H17V13.84H4V15.84C4 16.39 4.45 16.84 5 16.84H16L20 20.84V5.84C20 5.29 19.55 4.84 19 4.84ZM15 10.84V1.84C15 1.29 14.55 0.839996 14 0.839996H1C0.45 0.839996 0 1.29 0 1.84V15.84L4 11.84H14C14.55 11.84 15 11.39 15 10.84Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid5);
export default __webpack_public_path__ + "static/media/grid5.608c349e7deb30d8ebe8def5d3fa5982.svg";
export { ForwardRef as ReactComponent };